<template lang="pug">
.order-lines
  app-entity-relation(
    v-bind="{ ...slotProps, slotProps, handlingUnitsList, orderlineStatuses, errors }",
    :extraLoads="['orderLines.CollectionPoint', 'orderLines.DeliveryPoint', 'orderLines.Product', 'orderLines.ExtraData', 'orderLines.orderLineContacts']",
  )
</template>

<script>
import axios from 'axios';

export default {
  props: {
    slotProps: null,
    errors: null,
  },
  data: () => ({
    handlingUnitsList: [],
    orderlineStatuses: [],
  }),
  async created() {
    try {
      this.handlingUnitsList = (await axios.get('HandlingUnit?Where[]=h => h.Entity.Contains("OrderLine") || h.Entity = null', {params: { pageSize: -1 }})).data.data;
      this.orderlineStatuses = (await axios.get('Status?where[]=entity="OrderLine"', {params: { pageSize: -1 }})).data.data;
    } catch(error) {
      console.log(this.$cleanString(error));
    }
  },
}
</script>
